import { useReveal, Image, VideoLoop } from '@ccg/core';
import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Grid$1 from '../Grid/Grid.js';
import Text$1 from '../../basics/Text/Text.js';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';
import Tags$1 from '../Tags/Tags.js';
import StyledStage from './Stage.style.js';

const Stage = (_ref) => {
  let {
    authorUser,
    breadcrumbLink,
    headline,
    image,
    loop,
    newsFormat,
    tags,
    subline,
    postDate,
    video,
    excerpt,
    title,
    employmentType,
    seniority,
    schedule
  } = _ref,
      props = _objectWithoutProperties(_ref, ["authorUser", "breadcrumbLink", "headline", "image", "loop", "newsFormat", "tags", "subline", "postDate", "video", "excerpt", "title", "employmentType", "seniority", "schedule"]);

  const [ref, isVisible] = useReveal();
  return /*#__PURE__*/React$1.createElement(StyledStage, _extends({
    ref: ref,
    hasMedia: Boolean(image || video),
    authorUser: authorUser
  }, props), /*#__PURE__*/React$1.createElement(Grid$1, null, image || video ? /*#__PURE__*/React$1.createElement("div", {
    className: "stage__image"
  }, /*#__PURE__*/React$1.createElement(RevealBox$1, {
    isVisible: isVisible,
    direction: "left"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "stage__image-wrapper"
  }, image && !video ? /*#__PURE__*/React$1.createElement(Image, {
    src: image.url || image.src,
    ratio: "16:9",
    srcset: image.srcset,
    alt: image.alt,
    sizes: "100vw",
    lazy: true
  }) : null, video ? /*#__PURE__*/React$1.createElement(VideoLoop, {
    src: video.url,
    loop: loop,
    autoPlay: true
  }) : null)), /*#__PURE__*/React$1.createElement("div", {
    className: "stage__scroll"
  })) : null, /*#__PURE__*/React$1.createElement("div", {
    className: "stage__breadcrumb"
  }, breadcrumbLink && /*#__PURE__*/React$1.createElement(Link$1, _extends({
    className: "stage__breadcrumbLink"
  }, breadcrumbLink), breadcrumbLink.label && breadcrumbLink.label), /*#__PURE__*/React$1.createElement("span", null, title && title)), /*#__PURE__*/React$1.createElement("div", {
    className: "stage__headline"
  }, newsFormat && /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "small",
    as: "p",
    reveal: true,
    isVisible: isVisible,
    className: "stage__news-format"
  }, newsFormat), /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    as: "h1",
    variant: "headline",
    reveal: true,
    isVisible: isVisible,
    text: headline || title
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "stage__info"
  }, tags && tags.length > 0 && /*#__PURE__*/React$1.createElement(Tags$1, {
    tags: tags,
    horizontal: true,
    className: "stage__tags"
  }), subline && /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "subheadline",
    as: "h2",
    reveal: true,
    isVisible: isVisible,
    revealVariant: "secondary",
    className: "stage__subline"
  }, subline), (authorUser || postDate) && /*#__PURE__*/React$1.createElement("div", {
    className: "stage__meta"
  }, authorUser && authorUser.image && /*#__PURE__*/React$1.createElement("div", {
    className: "stage__author-image-wrapper"
  }, /*#__PURE__*/React$1.createElement(Image, {
    ratio: "1:1",
    src: authorUser.image.url,
    srcset: authorUser.image.srcset,
    className: "stage__author-image",
    alt: authorUser.image.alt || authorUser.fullName
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "stage__meta-aside"
  }, authorUser && authorUser.fullName && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "stage__author"
  }, authorUser.fullName), authorUser && authorUser.position && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "stage__author-position"
  }, authorUser.position), postDate && /*#__PURE__*/React$1.createElement("time", {
    className: "stage__post-date",
    dateTime: postDate
  }, postDate), employmentType && employmentType.length > 0 && employmentType.map(category => {
    return /*#__PURE__*/React$1.createElement("span", {
      key: category.id,
      className: "stage__meta-entry"
    }, category.title);
  }), seniority && seniority.length > 0 && seniority.map(category => {
    return /*#__PURE__*/React$1.createElement("span", {
      key: category.id,
      className: "stage__meta-entry"
    }, category.title);
  }), schedule && schedule.length > 0 && schedule.map(category => {
    return /*#__PURE__*/React$1.createElement("span", {
      key: category.id,
      className: "stage__meta-entry"
    }, category.title);
  })))), excerpt && /*#__PURE__*/React$1.createElement(Text$1, {
    content: excerpt,
    className: "stage__excerpt"
  })));
};

Stage.propTypes = {
  title: PropTypes$1.string.isRequired,
  authorUser: PropTypes$1.shape({
    fullName: PropTypes$1.string,
    image: PropTypes$1.shape(),
    position: PropTypes$1.string
  }),
  breadcrumbLink: PropTypes$1.shape(),
  headline: PropTypes$1.string.isRequired,
  image: PropTypes$1.shape({
    src: PropTypes$1.string,
    url: PropTypes$1.string,
    srcset: PropTypes$1.shape(),
    alt: PropTypes$1.string,
    width: PropTypes$1.number,
    height: PropTypes$1.number
  }),
  newsFormat: PropTypes$1.string,
  loop: PropTypes$1.bool,
  postDate: PropTypes$1.string,
  tags: PropTypes$1.arrayOf(PropTypes$1.shape({
    title: PropTypes$1.string,
    id: PropTypes$1.string
  })),
  subline: PropTypes$1.string,
  video: PropTypes$1.shape({
    url: PropTypes$1.string
  }),
  excerpt: PropTypes$1.string,
  employmentType: PropTypes$1.arrayOf(PropTypes$1.shape({
    title: PropTypes$1.string,
    id: PropTypes$1.number
  })),
  seniority: PropTypes$1.string,
  schedule: PropTypes$1.string
};
Stage.defaultProps = {
  authorUser: null,
  breadcrumbLink: null,
  image: undefined,
  newsFormat: null,
  loop: true,
  postDate: null,
  subline: null,
  tags: [],
  video: null,
  excerpt: null,
  employmentType: [],
  seniority: null,
  schedule: null
};

export default Stage;
